export interface CatalogOperator {
	OperatorId: number | null;
	OperatorName: string;
	Enabled: boolean;
	IsActive: boolean;
}

export const CATALOG_OPERATOR_INITIAL_VALUES: CatalogOperator = {
	OperatorId: null,
	OperatorName: "",
	Enabled: true,
	IsActive: true,
};
